import { Component, OnInit, NgZone, ViewChild, OnDestroy } from "@angular/core";
import { take, takeUntil } from "rxjs/operators";

import { ReplaySubject, Subscription } from "rxjs";
import { DatePipe } from "@angular/common";
import { PatientNotesDialogComponent } from "../patient-notes-dialog/patient-notes-dialog.component";
import { MatDrawer, MatSidenav } from "@angular/material/sidenav";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";

import { IencounterSearch } from "../../interface/IencounterSearch";
import { DocumentuploadComponent } from "../../shared/documentupload/documentupload.component";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { SearchHeaderService } from "../../services/SsearchHeader.service";
import { EncounterModel } from "../../interface/Iencounter";
import { OPD_REPORT_TYPE } from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { ConfirmRemarksComponent } from "../patient-appointment/confirm-remarks/confirm-remarks.component";
import { patientGetDataservice } from "../../services/SpatientGetData.service";
import { ConfirmCheckoutComponent } from "../../shared/confirm-checkout/confirm-checkout.component";
import { KinDetailsDialogComponent } from "../../shared/kin-details-dialog/kin-details-dialog.component";
import { CancelVisitComponent } from "../../shared/cancel-visit/cancel-visit.component";
import { AccountDetailsDialogComponent } from "../../shared/account-details-dialog/account-details-dialog.component";
import { CookieService } from "ngx-cookie-service";
import { ChangeProviderComponent } from "../../shared/change-provider/change-provider.component";
import { Router } from "@angular/router";
import moment from "moment";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { BarcodeScannerComponent } from "projects/lib/medcare-core-lib/src/lib/core/barcode-scanner/barcode-scanner.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { MasterMenus, DocumentUploadEnum, Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { ElasticService } from "projects/lib/medcare-core-lib/src/lib/services/elastic.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { ReportService } from "projects/lib/medcare-core-lib/src/lib/services/report.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";

@Component({
  selector: "app-patient-encounter-list",
  templateUrl: "./patient-encounter-list.component.html",
  styleUrls: ["./patient-encounter-list.component.scss"],
  providers: [DatePipe],
})
export class PatientEncounterListComponent implements OnInit, OnDestroy {
  @ViewChild("drawerEncounter") drawerEncounter: MatSidenav;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = OPD_CONST.displayEncounterList;
  dataSource = new MatTableDataSource<EncounterModel>();
  search = {} as IencounterSearch;
  private subscriptionList = new Subscription();
  totalDataLength: number = 0;
  pageSize: number = 0;
  paginatorOptions: any;
  offsetData: number = 0;
  selectedEncounter: EncounterModel;
  statusCounts: {
    arrived: number;
    cancelled: number;
    checkedIn: number;
    Finished: number;
    emergency: number;
    vip: number;
    draft: number;
    checkout:number;
    convertIP:number;
  } = {
    arrived: 0,
    cancelled: 0,
    checkedIn: 0,
    Finished: 0,
    emergency: 0,
    vip: 0,
    draft: 0,
    checkout:0,
    convertIP:0,
  };
  departmentText: string = "Department";
  appConfig: any = {};
  screenConfiguration: {
    hasSecondPatientLabelBarcode: boolean;
  } = {
    hasSecondPatientLabelBarcode: false,
  };
  previousInternalNotes: any[] = [];
  pageIndex: number = 0;
  selectedRow: number = -1;
  userRightList: any = [];
  isCancelSplRight: boolean = false;
  isVip:boolean=false;
  isEncounterFilterList:boolean=false;
  isDrawerOpen:boolean=false;
  internalList:any[]=[];
  userAutho: any;
  userName: string;
  account: any[] = [];
  nextOfKin: any[] = [];
  BarCode: string;
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  data: any;
  @ViewChild("drawer") drawer: MatDrawer;
  langaugeValue:string="";
  constructor(
    private ngZone: NgZone,
    private httpService: AppBaseService,
    private searchService: SearchService,
    public datePipe: DatePipe,
    private patientService: PatientService,
    private appConfigurtion: ApplicationConfigService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public elasticService: ElasticService,
    public searchHead: SearchHeaderService,
    private langService: MultiLanguageService,
    public generalApiService: GeneralUrlService,
    private reportService: ReportService,
    public authService: AuthService,
    public patientDataService: patientGetDataservice,
    public cookieService: CookieService,
    private env: EnvoirnmentService,
    public baseservice: AppBaseService,
    public router:Router,
    private thConvertService:thEnConverterService
  ) {}

  /**
   *load method
   *
   * @memberof PatientEncounterListComponent
   */
  ngOnInit() {
    this.pageSize = 15;
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.checkStartEndDates();
    this.getSearchFilter();
    this.getUserInfo();
     this.langaugeValue=localStorage.getItem("lan");
    this.langService.changeFooterLaber().then((val) => {
      if(this.paginator){
      this.paginator._intl.itemsPerPageLabel = val;
      }
    });
  }

  /**
   *Destroy method
   *
   * @memberof PatientEncounterListComponent
   */
  ngOnDestroy() { 
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.subscriptionList.unsubscribe();
  }
  /**
   *get user right details
   *
   * @memberof PatientEncounterListComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      this.userAutho = value.autho;
      this.userName = value.email;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightCancelCode)
            this.isCancelSplRight = true;
        });
      }
    });
  }
  /**
   *search filter option
   *
   * @memberof PatientEncounterListComponent
   */
  public getSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_ENCOUNTER_SEARCH)
        .subscribe((data: any) => {
          this.searchHead.updateSearchHeader(data);
        })
    );
    this.subscriptionList.add(
      this.searchService.getResult.subscribe((res) => {
        this.setSearchurl(res);
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrnno: quickSearch };
        this.setSearchurl(result);
      }
    );
    this.subscriptionList.add(quickSearch);
    this.getAllEncounters();
    this.getStatusWiseCount();
  }

  /**
   *set search
   *
   * @param {*} result
   * @memberof PatientEncounterListComponent
   */
  setSearchurl(result) {
    if (result.daterange && result.daterange.startDate) {
      this.search.fromDate =new Date(new Date(result.daterange.startDate.$d).setHours(0, 0, 0, 0));
    } else {
      this.search.fromDate = null;
    }
    if (result.daterange && result.daterange.endDate) {
      this.search.toDate = new Date(new Date(result.daterange.endDate.$d).setHours(23, 59, 59, 999));
      var today = this.epochConverter(this.search.fromDate);
      var sameDay = this.epochConverter(this.search.toDate);
      if (today == sameDay)
        this.search.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    } else {
      this.search.toDate = null;
    }
    this.search.mrn = result.mrnno;
    this.search.pname = result.patientName ? result.patientName : "";
    this.search.department = result.department
      ? result.department.desc.toUpperCase()
      : "";
    this.search.doctor = result.doctor ? result.doctor.desc.toUpperCase() : "";
    this.search.unit = result.searchunit;
    this.search.encounterNo = result.encounterNo ? result.encounterNo : "";
    this.search.status = result.status ? result.status.code : "";
    this.getAllEncounters();
    this.getStatusWiseCount();
  }
  
  /**
   * get configuration
   */
  getAppConfig() {
    this.subscriptionList.add(
      this.appConfigurtion
        .getModuleConfiguration(MasterMenus.OPD, OPD_CONST.encounter)
        .subscribe((config) => {
          if (config) {
            this.appConfig = config;
            this.appConfig.forEach((element) => {
              if (element.key == OPD_CONST.departmentText) {
                this.departmentText = element.valueList[0].desc;
              }
            });
          }
        })
    );
  }

  /**
   *get status wise count
   *
   * @memberof PatientEncounterListComponent
   */
  getStatusWiseCount() {
    let frDate =this.epochConverter(this.search.fromDate)
    let toDate =this.epochConverter(this.search.toDate)
    let fromDate = this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(frDate): frDate 
    let convertedToDate = this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(toDate): toDate;
    let status = this.search.status === undefined ? "" : this.search.status;
    let reqPayload =
      this.search.mrn +
      "&encounterNumber=" +
      this.search.encounterNo +
      "&frDate=" +
      fromDate +
      "&toDate=" +
      convertedToDate +
      "&id=&encounterToken=" +
      this.search.encounterNo +
      "&encounterDate=" +
      "&offset=" +
      this.offsetData +
      "&size=" +
      this.pageSize +
      "&doctorName=" +
      this.search.doctor +
      "&departmentName=" +
      this.search.department +
      "&name=" +
      this.search.pname +
      "&businessStatus=" + 
      status +
      "&visitType=OP&includedPatientData=false&isOpenEncounter="+this.isEncounterFilterList+"&groupedCount=true";
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
        )
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            const arrived = res.find((i) => i.display === "ARRIVED");
            this.statusCounts.arrived = arrived ? arrived.count : 0;
        
            const billed = res.find((i) => i.display === "BILLING COMPLETED");
            this.statusCounts.checkedIn = billed?.count || 0;
        
            const cancelled = res.find((i) => i.display === "CANCELLED");
            this.statusCounts.cancelled = cancelled?.count || 0;
        
            const finished = res.find((i) => i.display === "FINISHED");
            this.statusCounts.Finished = finished?.count || 0;

            const Checkout = res.find((i) => i.display === "CHECKOUT");
            this.statusCounts.checkout = Checkout?.count || 0;

            const convertToIP = res.find((i) => i.display === "CONVERTED TO IP");
            this.statusCounts.convertIP = convertToIP?.count || 0;
          }
        })
    );
  }

  /**
   *get all encounter details
   *
   * @memberof PatientEncounterListComponent
   */
  getAllEncounters() {
    let frDate =this.epochConverter(this.search.fromDate)
    let toDate =this.epochConverter(this.search.toDate)
    let fromDate = this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(frDate): frDate 
    let convertedToDate = this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(toDate): toDate;
    let status = this.search.status === undefined ? "" : this.search.status;
    let list: EncounterModel[] = [];
    let reqPayload =
      this.search.mrn +
      "&encounterNumber=" +
      this.search.encounterNo +
      "&frDate=" +
      fromDate +
      "&toDate=" +
      convertedToDate +
      "&id=&encounterToken=" +
      "&encounterDate=" +
      "&offset=" +
      this.offsetData +
      "&size=" +
      this.pageSize +
      "&doctorName=" +
      this.search.doctor +
      "&departmentName=" +
      this.search.department +
      "&name=" +
      this.search.pname +
      "&businessStatus=" + 
      status +
      "&visitType=OP&includedPatientData=false&isOpenEncounter="+this.isEncounterFilterList+"&groupedCount=false";
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
        )
        .subscribe((res: any) => {
          let encounterIdList: any[] = [];
          if (res && res.response.length > 0 && res.response) {
            this.totalDataLength = res.totalRecords;
            res.response.forEach((element) => {
              try {
                var encounterDate = element.createdDate;
                var encounterDate_d = new Date(0);
                encounterDate_d.setUTCSeconds(encounterDate);
                let patientName: string = "-";
                let patientAge = "";
                let patientId = "";
                let gender = "";
                let genderv = "";
                let address = "";
                let mobileno = "";
                let email = "";
                let identificationType = "";
                let identificationId = "";
                let photo = "";
                let dobFormatted="";
                if (element.patientDetails) {
                  let patient = element.patientDetails;
                  patientName = patient.patientName ? patient.patientName : "-";

                  patientId = patient.id;
                  if (patient.birthDate) {
                    let age = this.patientService.calculateAge(
                      new Date(patient.birthDate)
                    );
                    patientAge = age.years;
                  }
                   dobFormatted =  this.langaugeValue== Langauge.TH?this.thConvertService.convertThaiDateString(patient.birthDate):this.datePipe.transform(
                    patient.birthDate,
                    "yyyy-MM-dd"
                  );

                  if (patient.gender) {
                    gender = patient.gender.display.toString().toUpperCase();
                    genderv = gender == "MALE" ? "M" : "F";
                  }
                }
                encounterIdList.push(element.id);
                let date = null;
                if (
                  element.appointmentReference &&
                  element.appointmentReference.id
                ) {
                  date = element.appointmentReference.display;
                }
               
                const encounter: EncounterModel = {
                  EncounterId: element.id,
                  Color: this.getStatusColor(element.businessStatus),
                  EncounterNumber: element.encounterNumber,
                  VisitType:element.encounterType?element.encounterType.display:"",
                  MRN: element.mrn,
                  EncounterToken: element.encounterToken,
                  PatientId: patientId,
                  PatientName: patientName,
                  patientImage: this.getGenderValue(gender),
                  PatientGender: gender,
                  PatientAge: this.calculateAge(element.patientDetails.birthDate),
                  age : this.convertDateFormat(dobFormatted) + genderv,
                  PatientMobileno: mobileno,
                  PatientEmailId: email,
                  PatientPhoto: photo,
                  IdentificationNo: identificationId,
                  IdentificationType: identificationType,
                  DoctorName: element.doctor ? element.doctor.display : "",
                  DepartmentName: element.department
                    ? element.department.display
                    : "",
                  referralType:
                    element.encounterReferral &&
                    element.encounterReferral.encounterReferralType
                      ? element.encounterReferral.encounterReferralType.display
                      : "-",
                  VisitDate: this.langaugeValue== Langauge.TH ?this.thConvertService.convertToThaiDate(element.createdDate) :encounterDate_d,
                  AppointmentDate: date ? date : "",
                  time :this.formatDateWithRelativeTime(encounterDate_d),
                  BillNumber: "-",
                  Address: address ? address : "-",
                  IsMedicationPrescribed: false,
                  Diagnosis: "-",
                  Advise: "-",
                  ReferenceDoctor: element.encouterReferralTypeName
                    ? element.encouterReferralTypeName.display
                    : "-",
                  Clinic:
                    element.clinic && element.clinic.display
                      ? element.clinic.display
                      : "-",
                  clinicId: element.clinicId ? element.clinicId : "",
                  Triage: "-",
                  Status: this.getstatusColor(element.businessStatus),
                  BusinessStatus : element.businessStatus ? element.businessStatus : "",
                  BillingStatus: element.isBilled,
                  CompanyDetails: element.account,
                  outStandingAmount: element.outStandingAmount
                    ? element.outStandingAmount
                    : 0,
                  reference:element.appointmentReference ? element.appointmentReference.reference==OPD_CONST.EXTENDED_APPOINTMENT?"":element.appointmentReference.reference :"",
                  Remarks: element.sourceRemarks ? element.sourceRemarks : " ",
                  Data: element,
                  rowCount: 0,
                  previousNotes: element.encounterNote
                    ? element.encounterNote
                    : [],
                    isVip:element.patientDetails?element.patientDetails.isVip:false,
                  statusValue: element.legend ? element.legend : null,
                  glStatus: this.getGlStatusColor(element.glStatus),
                  isPdpaRequired :element.isPdpaRequired,
                  defaultDeposit:element.defaultDeposit?element.defaultDeposit:'',
                  isNoteVisible:element.patientDetails.patientNoteDetails?element.patientDetails.patientNoteDetails.note:""
                };
                list.push(encounter);
              } catch (ex) {
                console.error(ex);
              }
            });
            this.dataSource = new MatTableDataSource<any>(list);
          }else{
            this.dataSource = new MatTableDataSource<any>([]);
          }
        })
    );
  }
  convertDateFormat(dateStr: string): string {
    if (!dateStr) {
      return '';
    } 
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year} / `;
  }
  formatDateWithRelativeTime(date: Date): string {
    if (!date) {
      return '';
    }
    let newDate = new Date();
    const relativeTime = moment(date).fromNow(); 
    return `(${relativeTime})`;
  }
  calculateAge(dateOfBirth: string): string {
    if (!dateOfBirth) {
      return '';
    }
    let birthDate = new Date(dateOfBirth);
    let currentDate = new Date();
  
    let years = currentDate.getFullYear() - birthDate.getFullYear();
    let months = currentDate.getMonth() - birthDate.getMonth();
    let days = currentDate.getDate() - birthDate.getDate();
    if (days < 0) {
      months--;
      days += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    return `${years} Y, ${months} M, ${days} D`;
  }

  getGenderValue(value: string): string {
    switch (value) {
      case "MALE":
        return "male-blue.png";
      case "FEMALE":
        return "female-pink.png";
      default:
        return "male-blue.png";
    }
  }

  /**
   *status color
   *
   * @param {string} status
   * @return {*}  {string}
   * @memberof PatientEncounterListComponent
   */
  getStatusColor(status: string): string {
    switch (status) {
      case "ARRIVED":
        return "#93f493";
      case "CHECKEDIN":
        return "#9090f3";
      case "CANCELLED":
        return "#c86a6a";
      case "ADMITTED":
        return "lightGreen";
      case "FINISHED":
        return "#d0c064";
      case "BILLING COMPLETED":
        return "lightblue";
      case "CONVERTED TO IP":
        return "#BF77F6";
      case "CHECKOUT":
        return "gray";
      default:
        break;
    }
  }

  getGlStatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case "Received":
        style.text = "Received";
        style.backgroundColor = "babyblue";
        break;
      case "In Progress":
        style.text = "In Progress";
        style.backgroundColor = "#f1c6a0";
        break;
      case "Completed":
        style.text = "Completed";
        style.backgroundColor = "#e3c674";
        break;
      case "Others":
        style.text = "Others";
        style.backgroundColor = "lightskyblue";
        break;
      case "PENDING GL":
        style.text = "Pending";
        style.backgroundColor = "#f09390";
        break;
      case "APPROVED GL":
        style.text = "Approved";
        style.backgroundColor = "#94ecc7";
        break;
      case "DECLINED GL":
        style.text = "Declined";
        style.backgroundColor = "#d977b7";
        break;
      case "NA":
        style.text = "NA";
        style.backgroundColor = "#ffcdcd";
        break;
      default:
        break;
    }
    return style;
  }

  openBarcodeScanDialog() {
    const dialogRef = this.dialog.open(BarcodeScannerComponent, {
      width: "650px",
      data: { },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.applyFilter(result);
        }
      })
    );
  }

  /**
   *
   * @param BarCode
   */
  applyFilter(BarCode) {
    this.search.mrn=BarCode;
    this.getAllEncounters();
    this.getStatusWiseCount();
    this.dataSource.filter = BarCode.trim().toLowerCase();
  }


  /**
   * add internal notes
   *
   * @memberof PatientEncounterListComponent
   */
  addInternalNotes() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 3000,
      }
    );
    this.previousInternalNotes = this.selectedEncounter.previousNotes;
    const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listNotes: this.previousInternalNotes,
        name: "EncounterList",
        encounterId: this.selectedEncounter.EncounterId,
        encounterno:this.selectedEncounter.EncounterNumber,
        isPrint:true
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getAllEncounters();
        this.getStatusWiseCount();
        this.previousInternalNotes = [];
        this.selectedRow = -1;
      })
    );
  }

  /**
   *Upload document
   *
   * @memberof PatientEncounterListComponent
   */
  uploadDocument() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
    this.dialog.open(DocumentuploadComponent, {
      height: "350px",
      width: "1000px",
      data: {
        MRN: this.selectedEncounter.MRN,
        EncounterNumber: this.selectedEncounter.EncounterNumber,
        screenCode:DocumentUploadEnum.ENCOUNTER_SCREEN
      },
    });
  }

  getKinDetails() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
    const dialogRef = this.dialog.open(KinDetailsDialogComponent, {
      height: "200px",
      width: "1000px",
      data: {
        id: this.selectedEncounter.EncounterId,
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.nextOfKin = res;
        }
      })
    );
}

cancelVisit(res: boolean) {
  if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
  const dialogRef = this.dialog.open(CancelVisitComponent, {
    width: "300px",
    height: "auto",
    data: {
      id: this.selectedEncounter.EncounterId,
      confirm: "cancel",
      isCancel: true,
    },
  });
  this.subscriptionList.add(
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let patchRequestData = {
          status: OPD_CONST.businessStatusList.CANCELLED,
          isConvertToOP: result.isConvertToOP,
          reason: [
            {
              system: "EN",
              code: result.reason.code,
              display: result.reason.desc,
            },
          ],
          remarks: result.remark ? result.remark : "",
        };
        this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
        this.baseservice
          .putResource(
            OPD_API_URL.ADMISSION_UPDATE_STATUS + this.selectedEncounter.EncounterId,
            patchRequestData
          )
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(() => {
            this.snackBar.open(
              this.langService.get("adt.admissionCancelled"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 3000,
              }
            );
            this.getAllEncounters();
            this.getStatusWiseCount();
          });
        }
      })
    );
  }

  /**
   * deposit in different tab
   */
  getDepositDetails() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
    if (this.selectedEncounter) {
      this.cookieService.set("IsLoggedin", "true", 1, "/");
      this.cookieService.set("MRN", this.selectedEncounter.MRN , 1 , "/");
      this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
      this.cookieService.set("USER_NAME", btoa(this.userName), 1, "/");
      window.open(this.env.medcareUrl +"/billing"+ "/#/billing/deposit/deposit");
    }
  }

  getAccountDetails() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
    const dialogRef = this.dialog.open(AccountDetailsDialogComponent, {
      width: "1000px",
      height: "220px",
      data: {
        id: this.selectedEncounter.EncounterId,
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.account = res;
        }
      })
    );
  }

  /**
   * guarantee letter in different tab
   */
  getGuaranteeLetterDetails() {
    if (!this.selectedEncounter) 
    return this.snackBar.open(
      this.langService.get("CommonAppoinment.pleaseselectencounter"),
      this.langService.get("CommonAppoinment.validation"),
      {
        duration: 1000,
      }
    );
    if (this.selectedEncounter) {
      this.cookieService.set("IsLoggedin", "true", 1, "/");
      this.cookieService.set("MRN", this.selectedEncounter.MRN, 1 , "/");
      this.cookieService.set("encounterId", this.selectedEncounter.EncounterId, 1 , "/");
      this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
      this.cookieService.set("USER_NAME", btoa(this.userName), 1, "/");
      this.router.navigate(["/OPD/updateSponsor"])
    }
  }

  cancelEncounter() {
    if (this.getPatient()) {
      let payload = {
        visitNo: this.data.EncounterNumber,
      };
      this.baseservice.setResourceURL(MICROSERVICES.BILLING_SERVICE);
      this.baseservice
        .postResource(OPD_API_URL.OPEN_CHARGES, payload)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.cancelEncounterVisit(res.openCharge);
        });
    }
  }

  getPatient() {
    if ((this.data = this.selectedEncounter)) {
      return true;
    } else {
      this.snackBar.open(
          this.langService.get("CommonAppoinment.pleaseselectpatient"),
          this.langService.get("CommonAppoinment.warning"),
        {
          duration: 1000,
        }
      );
      return false;
    }
  }

  /**
   *Cancel Encounter
   *
   * @memberof PatientEncounterListComponent
   */
   cancelEncounterVisit(openCharge: boolean) {
    if (openCharge == true) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("EncounterPage.Cancellationnotallowed"),  
        {
          duration: 3000,
        }
      );
    } else if (this.selectedEncounter.BillingStatus) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
          this.langService.get("EncounterPage.outstandingCancellation"),
        {
          duration: 500,
        }
      );
    } else {
      const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
        width: "300px",
        data: { dialogName: "Cancel Visit",
        pageName:"PatientEncounterList" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          var remarks = result;
          if (remarks.action != "no") {
            let patchRequestData = {
              status: OPD_CONST.businessStatusList.CANCELLED,
              remarks: result.remarks ? result.remarks : "",
              reason: result.reason
                ? this.langService.createObjectList(result.reason[0])
                : "",
            };
            this.httpService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.subscriptionList.add(
              this.httpService
                .putResource(
                  OPD_API_URL.OPD_ENCOUNTER_UPDATE +
                    this.selectedEncounter.EncounterId,
                  patchRequestData
                )
                .subscribe(() => {
                  this.snackBar.open(
                    this.langService.get("CommonAppoinment.encountercancelled"),
                    this.langService.get("CommonAppoinment.success"),
                    {
                      duration: 300,
                    }
                  );
                  this.getAllEncounters();
                  this.getStatusWiseCount();
                })
            );
          }
          this.getAllEncounters();
          this.getStatusWiseCount();
        })
      );
    }
  }

  /**
   *check start dates
   *
   * @memberof PatientEncounterListComponent
   */
  checkStartEndDates() {
    if (this.search && !this.search.fromDate) {
      this.search.fromDate = new Date(new Date().setHours(0, 0, 0, 0));
    }
    if (this.search && !this.search.toDate) {
      this.search.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    }
    this.search.mrn = "";
    this.search.encounterNo = "";
    this.search.department = "";
    this.search.pname = "";
    this.search.doctor = "";
  }

  /**
   *epoch converted method
   *
   * @param {*} strDate
   * @return {*}
   * @memberof PatientEncounterListComponent
   */
  epochConverter(strDate) {
    if (strDate) {
      const datum = Date.parse(strDate);
      const epoch = datum / 1000;
      return epoch;
    } else return "";
  }

  /**
   *next event
   *
   * @param {*} event
   * @memberof PatientEncounterListComponent
   */
  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex ;
    this.offsetData = event.pageIndex *event.pageSize;
    this.getAllEncounters();
    this.getStatusWiseCount();
  }

  /**
   *get encounter model
   *
   * @param {number} index
   * @param {EncounterModel} element
   * @memberof PatientEncounterListComponent
   */
  getEncounter(index: number, element: EncounterModel) {
    // if (this.selectedRow == -1) this.selectedRow = index;
    // else this.selectedRow = -1;
    // let reqPayload =
    //   "identificationId=&name=&id=" +
    //   element.PatientId +
    //   "&gender=&unitCode=&city=&identificationType=&frDate=&toDate=&mrn=&mobile=&birthDate=&offset=&size=&pincode=&country=&state=";
    // this.generalApiService
    //   .getTypeApi(
    //     OPD_API_URL.OPD_SERVICE,
    //     OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
    //   )
    //   .subscribe((res: any[]) => {
    //     let pateintData = this.patientDataService.displayList(res);
    //     (element.Address = pateintData[0].extendedAddress
    //       ? pateintData[0].extendedAddress.addressLine
    //       : ""),
    //       (element.PatientMobileno = pateintData[0].mobileNumber
    //         ? pateintData[0].mobileNumber
    //         : ""),
    //         element.IdentificationNo=pateintData[0].idNo,
    //         element.IdentificationType= pateintData[0].identifierType ? pateintData[0].identifierType : "",
    //         element.PatientPhoto= pateintData[0].photo ? pateintData[0].photo : OPD_CONST.imagePath,
    //         element.PatientEmailId=pateintData[0].emailId?pateintData[0].emailId:"",
    //       (this.selectedEncounter = element);
    //       this.isVip=res?res[0].vip:false;
    //   });

      this.selectedRow = index;
      this.selectedEncounter = element;
  }

  /**
   *on close method
   *
   * @memberof PatientEncounterListComponent
   */
   onClose() {
    this.isDrawerOpen = false;
    this.selectedRow = -1;
  }

  /**
   *printReport
   *
   * @param {*} encounterId
   * @param {*} reportName
   * @memberof PatientEncounterListComponent
   */
  printReport(encounter, reportName) {
    if (!this.selectedEncounter) {
      return this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectencounter"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
  
    if (reportName=="pdpaFormnew" && !this.selectedEncounter.isPdpaRequired) {
      return this.snackBar.open(
        this.langService.get("CommonAppoinment.pdpaNotRequired"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
    if (reportName=="encounterDefaultDepositSlip" && !this.selectedEncounter.defaultDeposit) {
      return this.snackBar.open(
        "Default deposit is not present",
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
    let reqPayload = {
      transactionId: encounter.EncounterId,
      type: OPD_REPORT_TYPE.pdf,
      reportName: reportName,
      isReports: false,
    };
    localStorage.removeItem(OPD_CONST.reportPayload);
    localStorage.setItem(OPD_CONST.reportPayload, JSON.stringify(reqPayload));
    window.open(opdNavigation.REPORT_NAVIGATE);
  }

  /**
   *tabel sticks
   *
   * @type {MatTable<any>}
   * @memberof PatientEncounterListComponent
   */
  @ViewChild(MatTable) table: MatTable<any>;
  ngAfterViewInit() {
    this.ngZone.onMicrotaskEmpty
      .pipe(take(3))
      .subscribe(() => this.table.updateStickyColumnStyles());
  }

  openEncounterFilterList(result){
    this.isEncounterFilterList=result.target.checked?result.target.checked:false;
    this.getAllEncounters();
    this.getStatusWiseCount();
  }

  patientJourney() {
    if (!this.selectedEncounter) {
      return  this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectencounter"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 3000,
        }
      );
    }
  
    if (this.selectedEncounter.EncounterId) {
      this.drawer.toggle();
        this.internalList = [];
        this.subscriptionList.add(
          this.generalApiService
            .getTypeApi(
              OPD_API_URL.OPD_SERVICE,
              OPD_API_URL.AUDIT_TRAIL_HISTORY + "visitId=" + this.selectedEncounter.EncounterId
            )
            .subscribe((res: any) => {
              res.forEach((element) => {
                let obj = {
                  status: element.status ? element.status : "",
                  createdBy: element.createdBy ? element.createdBy : "",
                  createdOn: element.createdOn ? this.epochToDateConverter(element.createdOn) : "",
                  reason: element.reason ? element.reason :"",
                  remark: element.remarks ? element .remarks: "",
                };
                this.internalList.push(obj);
              });
            })
        );
    }
  }  

  confirmCheckout(value){
    if(value.BusinessStatus=='CANCELLED'|| value.BusinessStatus=='CHECKOUT'){
      this.snackBar.open(
        "Checkout is not allowed as the patient visit is canceled or already checked out","Validation",{duration: 1000,}
      );
    } else {
    const dialogRef =this.dialog.open(ConfirmCheckoutComponent, {
      height: "150px",
      width: "400px",
      data:{
        id:value.EncounterId?value.EncounterId:"",
        remark:value.Remarks?value.Remarks:"",
      }
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getAllEncounters();
        this.getStatusWiseCount();
        this.previousInternalNotes = [];
      })
    );
    }
  }

  epochToDateConverter(epoch: number): string {
    try {
      const epochString = epoch.toString().replace(/\D/g, '');
      const length = epochString.length;
     if (length == 10) {
      var d = new Date(0);
      d.setUTCSeconds(epoch);
     }
     else {
      var d = new Date(0);
      d.setUTCMilliseconds(epoch);
     }
      const datePipe = new DatePipe('en-US');
      const formattedDate = datePipe.transform(d, 'EEE, LLLL dd, yyyy , hh:mm a');
      return formattedDate;
    } catch (ex) {
      return '';
    }
  }

  /**
   * To refresh search
   */
  refreshSearch() {
    this.search.mrn = "";
    this.search.pname = "";
    this.offsetData = 0;
    this.pageSize = 15;
    this.search.fromDate =  new Date(new Date().setHours(0, 0, 0, 0));
    this.search.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    this.search.encounterNo = "";
    this.isEncounterFilterList = false;
    this.search.mrn = "";
    this.search.encounterNo = "";
    this.search.doctor = "";
    this.search.department = "";
    this.search.pname = "";
    this.search.status = "";
    this.getAllEncounters();
    this.getStatusWiseCount();
  }

  getstatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: status,  
      backgroundColor: "lightblue",
    };
    switch (status) {
      case "ARRIVED":
        style.text = "ARRIVED";
        style.backgroundColor = "#bef0bb";
        break;
      case "CHECKEDIN":
        style.text = "CHECKEDIN";
        style.backgroundColor = "blue";
        break;
      case "CANCELLED":
        style.text = "CANCELLED";
        style.backgroundColor = "#ffcdcd";
        break;
      case "ADMITTED":
        style.text = "ADMITTED";
        style.backgroundColor = "#9AF900";
        break;
      case "FINISHED":
        style.text = "FINISHED";
        style.backgroundColor = "#feed93";
        break;
        case "CONSULTED":
          style.text = "CONSULTED";
          style.backgroundColor = "#feed93";
          break;
      case "BILLING COMPLETED":
        style.text = "BILLING COMPLETED";
        style.backgroundColor = "#9CE3FB";
        break;
      case "CONVERTED TO IP":
        style.text = "CONVERTED TO IP";
        style.backgroundColor = "#DFB5FF";
        break;
      case "CHECKOUT":
        style.text = "CHECKOUT";
        style.backgroundColor = "#D8D8D8";
        break;
      default:
        break;
    }
    return style;
  }
  openChangeProvider(value){
    if (this.getPatient()) {
    if(value.BusinessStatus!=='ARRIVED'){
      this.snackBar.open(
        "Provider change is not permitted as the encounter is already in progress or complete.","Error",{duration: 2000,}
      );
    }else{
      const dialogRef =this.dialog.open(ChangeProviderComponent, {
        height: "450px",
        width: "600px",
        data:{
          id:value.EncounterId?value.EncounterId:"",
        }
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getAllEncounters(); 
    })
  )
}
}
}
getMedicationImage(element): string {
  if (element.statusValue) {
    if (element.statusValue.isMedicationVerified) {
      return './assets/images/encounter/drug.png';
    }
    if (element.statusValue.isMedicationOrdered) {
      return './assets/images/encounter/nondrug.png';
    }
  }
  return './assets/images/encounter/defdrug.png';
}
viewBill(mrn) {
  if (this.getPatient()) {
    this.cookieService.set("IsLoggedin", "true", 1, "/");
    this.cookieService.set("MRN", mrn , 1, "/");
    this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
    this.cookieService.set("USER_NAME", btoa(this.userName), 1, "/");
    window.open(this.env.medcareUrl+"/billing" + "/#/billing/bill/opbill");
  }}
}
